import { GWPButton } from 'shared-components';
import EntertainerShell from './EntertainerShell';

type Props = {
	status: 'success' | 'duplicate_email' | 'bot_detected';
	onStartAgain?: () => void;
};

const resultCopy = {
	success: {
		title: 'Application received',
		message:
			'Thanks for applying to perform with Goodwill Projects. Our team will review your details and get in touch.',
	},
	duplicate_email: {
		title: 'We already have an application for this email',
		message:
			'You do not need to apply again. If your details have changed, please contact the Goodwill Projects team.',
	},
	bot_detected: {
		title: 'We could not submit this application',
		message:
			'The anti-spam check was triggered. Return to the form and try again without using browser autofill on hidden fields.',
	},
};

export default function EntertainerApplicationResult({ status, onStartAgain }: Props) {
	const copy = resultCopy[status];
	return (
		<EntertainerShell compact>
			<section className={`entertainer-result ${status}`} aria-live="polite">
				<div className="entertainer-result-mark" aria-hidden="true">
					<span className="material-symbols-outlined">{status === 'success' ? 'task_alt' : 'error'}</span>
				</div>
				<h1>{copy.title}</h1>
				<p>{copy.message}</p>
				{status !== 'success' && onStartAgain ? (
					<GWPButton onClick={onStartAgain}>Return to application</GWPButton>
				) : null}
			</section>
		</EntertainerShell>
	);
}
